import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 6,
			r: 6,
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.98047 4L5.94085 5.94582L3.98047 7.88799",
			stroke: "white",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0791 4L6.11872 5.94582L8.0791 7.88799",
			stroke: "white",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		})
	]
});
export default SvgXMark;
